import Logo from "../pages/index/ucenter/Logo";
import Resume from "../pages/index/ucenter/Resume";
import Space from "../pages/index/ucenter/Space";
import Detect from "../pages/index/ucenter/Detect";
import Income from "@/pages/index/ucenter/Income";

export default [
   {
      path: "",
      name: "UCenter.Default",
      redirect: {name: "UCenter.Logo"}
   },
   {
      name: "UCenter.Logo",
      path: "logo",
      component: Logo,
      meta: {title: "个人形象", icon: "profile"}
   },
   {
      name: "UCenter.Resume",
      path: "resume",
      component: Resume,
      meta: {title: "摄影履历", icon: "camera"}
   },
   {
      name: "UCenter.Income",
      path: "income",
      component: Income,
      meta: {title: "账单明细", icon: "money-collect"}
   },
   {
      name: "UCenter.Space",
      path: "space",
      component: Space,
      meta: {title: "存储空间", icon: "database"}
   },
   {
      name: "UCenter.Detect",
      path: "detect",
      component: Detect,
      meta: {title: "人脸&号码", icon: "scan"}
   }
];
